function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h48v48H0z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)",
  stroke: "#0085FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23 6c5.849 0 11 3.616 11 12.5s-4.243 11.781-5.165 13.792c-.922 2.01-.835 2.52 4.12 4.172 4.956 1.68 4.764 4.016 4.764 4.016M23 6c-5.807 0-11 3.616-11 12.5s4.291 11.781 5.207 13.792c.915 2.01.83 2.52-4.09 4.172-4.921 1.68-4.837 4.016-4.837 4.016"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 23,
  r: 23
})), /*#__PURE__*/React.createElement("path", {
  d: "M43 37s-.891-2.152-3.842-3.151c-2.951-1-3.423-1.532-2.158-2.849 1.265-1.317 3-4 3-8 0-6-4-7-5-7M5 37s.891-2.152 3.842-3.151c2.951-1 3.423-1.532 2.158-2.849-1.265-1.317-3-4-3-8 0-6 4-7 5-7",
  stroke: "#0085FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
function SvgGroupsBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48
  }, props), _ref);
}
export default SvgGroupsBlue;